import { useMutation } from "@tanstack/react-query";
import { createData } from "@/lib/services/data-layer";
import { url } from "@/lib/services/data-layer/core";
import { verifyOtpProps, verifyOtpResponse } from "@/lib/types/DTO/core/auth";

const verifyOtp = async (data: verifyOtpProps): Promise<verifyOtpResponse> => {
  return createData(url + "auth/verify", data);
};

export const useVerifyOtpMutation = () => {
  const mutation = useMutation({
    mutationFn: (data: verifyOtpProps) => {
      return verifyOtp(data);
    },
  });
  return mutation;
};
